import { useContext, useEffect, useState, useRef } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MessageBarType } from '@bingads-webui-react/fabric-control';
import { useWebsiteSuggestion } from '@bingads-webui-campaign-react/add-image-hooks';
import { instrumentationScenarios } from '@bingads-webui-campaign/ad-creator-tools-instrumentation';

export const useImageSuggestionCarouselState = ({
  aid,
  cid,
  url,
  hasErrorInUrl,
  instrumentation,
  activity,
  permissions,
  oDataConfig,
}) => {
  // Should we create our own state to update the suggestion state?
  // Or should we just use the suggestion state from out side?
  const adCreatorScenario = instrumentationScenarios.CopilotDisplayAd;
  const i18n = useContext(I18nContext);
  const {
    suggestionState,
    suggestionPoller,
    dispatchSuggestionState,
  } = useWebsiteSuggestion({
    oDataConfig,
    adContext: { // Use the ad context to compose the API request url
      advertiserCustomerId: cid,
      accountId: aid,
    },
    instrumentation,
    logActivity: activity.trace,
    permissions,
    fullUrl: url,
    hasErrorInUrl,
    adCreatorScenario,
  });

  const { suggestion = {}, carousel = {} } = suggestionState;
  const isLoading = !!suggestion.inProgress;
  const requestSent = useRef(undefined);
  const [isUploading, setIsUploading] = useState(false);
  const [suggestionErrorMessage, setSuggestionErrorMessage] = useState(undefined);

  useEffect(() => {
    if (suggestion.inProgress === true) {
      requestSent.current = true;
    } else {
      if (requestSent.current === true && suggestion.images && suggestion.images.length === 0) {
        setSuggestionErrorMessage(i18n.getString(_TL_('We can’t generate asset recommendations from this Final URL.')));
      } else if (carousel.message && carousel.message.type === MessageBarType.error) {
        setSuggestionErrorMessage(carousel.message.message);
      } else {
        setSuggestionErrorMessage(undefined);
      }
      requestSent.current = false;
    }
  }, [i18n, suggestion.images, suggestion.inProgress, suggestion.error, carousel.message]);

  return {
    isUploading,
    setIsUploading,
    isLoading,
    suggestion,
    carousel,
    suggestionState,
    suggestionPoller,
    setSuggestionErrorMessage,
    suggestionErrorMessage,
    dispatchSuggestionState,
  };
};
